<template lang="pug">
  #sheets-preview
    .title-block
      .title {{ establishment._name }}
      .subtitle Les fiches suivantes vont être retirées de l'établissement
    .list-wrapper
      sheet-aggregate-list(
      :sheet-aggregates="sheetAggregates"
      :selectable="false"
      )
    .actions
      button.cancel-btn(@click="$emit('close')") Annuler
      button.previous-btn(disabled) Precédent
      button.next-btn(@click="goNext") Suivant
</template>

<script>
import SheetAggregateList from '@/components/sheet-aggregate-list/SheetAggregateList.vue';

export default {
  components: {
    SheetAggregateList,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
    sheetAggregates: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    goNext() {
      this.$router.push({ name: 'CreateOrMerge' });
    },
  },
}
</script>

<style lang="scss">
  #sheets-preview {
    .list-wrapper {
      flex-grow: 1;
      overflow-y: auto;
    }
    .title-block {
      margin-bottom: 1em;
    }
  }
</style>